import { hasUnsavedFormChanges } from "../../common/formStateDirty";
import { EmailFormState } from "./emailMockData";

type EmailFormDirtyComparisonInput = {
  baseline: EmailFormState;
  current: EmailFormState;
};

const sortUniqueStrings = <Value extends string>(
  values: readonly Value[],
): Value[] => Array.from(new Set(values)).sort();

const canonicalizeEmailFormForDirtyComparison = (
  email: EmailFormState,
): EmailFormState => ({
  ...email,
  builderState: { ...email.builderState, selectedBlockId: "" },
  recipientSourceIds: sortUniqueStrings(email.recipientSourceIds),
  memberFilters: {
    membershipTypeIds: sortUniqueStrings(email.memberFilters.membershipTypeIds),
    employeeRangeIds: sortUniqueStrings(email.memberFilters.employeeRangeIds),
    categoryIds: sortUniqueStrings(email.memberFilters.categoryIds),
    memberSinceRangeIds: sortUniqueStrings(
      email.memberFilters.memberSinceRangeIds,
    ),
    renewalRangeIds: sortUniqueStrings(email.memberFilters.renewalRangeIds),
  },
  recipientGroupIds: sortUniqueStrings(email.recipientGroupIds),
  selectedMemberIds: sortUniqueStrings(email.selectedMemberIds),
  governanceGroupIds: sortUniqueStrings(email.governanceGroupIds),
});

/**
 * Recipient and filter selections are sets. Their array order can change when
 * a user clears and reselects a value, but that order does not change the
 * audience. Ordered content, such as builder blocks and attachments, remains
 * unchanged in this comparison. The selected block is transient editor state.
 */
export const hasUnsavedEmailFormChanges = ({
  baseline,
  current,
}: EmailFormDirtyComparisonInput): boolean =>
  hasUnsavedFormChanges({
    baseline: canonicalizeEmailFormForDirtyComparison(baseline),
    current: canonicalizeEmailFormForDirtyComparison(current),
  });
